import React from 'react'
import { KindeProvider } from '@kinde-oss/kinde-auth-react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRoot } from 'react-dom/client'
import promiseFinally from 'promise.prototype.finally'
import './lib/logging/posthog'
import 'fomantic-ui-less/semantic.less'
import './styles/global.scss'
import { queryClient } from './lib/queryClient'

// Shim for older browsers
promiseFinally.shim()

// Suppress React defaultProps warnings
const originalWarn = console.warn
console.warn = (message, ...args) => {
  if (
    typeof message === 'string' &&
    (message.includes('Support for defaultProps will be removed') ||
      message.includes('findDOMNode is deprecated'))
  ) {
    return // Suppress this warning
  }
  originalWarn.apply(console, [message, ...args])
}

const originalWarn2 = console.error
console.error = (message, ...args) => {
  if (
    typeof message === 'string' &&
    (message.includes('Support for defaultProps will be removed') ||
      message.includes('findDOMNode is deprecated'))
  ) {
    return // Suppress this warning
  }
  originalWarn2.apply(console, [message, ...args])
}

import App from './App.jsx'
import { getKindeAudience } from './features/auth/lib/kindeOrg.js'

const container = document.getElementById('app')
const root = createRoot(container)

function main() {
  render()
}

// Rendering
function render(callback) {
  // Generate dynamic redirect URIs based on current deployment URL
  // This enables deploying the same build to multiple subdomains
  const dynamicRedirectUri = `${window.location.origin}/callback`
  const dynamicLogoutUri = `${window.location.origin}/login`

  const finalConfig = {
    clientId: process.env.REACT_APP_KINDE_CLIENT_ID,
    domain: process.env.REACT_APP_KINDE_DOMAIN,
    // Theme-aware audience — same helper AuthBridge uses on refresh
    audience: getKindeAudience(),
    redirectUri: dynamicRedirectUri,
    logoutUri: dynamicLogoutUri,
  }

  root.render(
    <KindeProvider
      clientId={finalConfig.clientId}
      domain={finalConfig.domain}
      audience={finalConfig.audience}
      redirectUri={finalConfig.redirectUri}
      logoutUri={finalConfig.logoutUri}
      useInsecureForRefreshToken={true}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        {process.env.NODE_ENV === 'development' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </KindeProvider>,
    document.getElementById('app'),
    callback,
  )
}

main()
